import { MAX_ZOOM, MIN_ZOOM } from "src/constants/zoom.constants";

export function calculateZoomValue(zoom: number, minZoomValue = MIN_ZOOM, maxZoomValue = MAX_ZOOM) {
  return Math.max(minZoomValue, Math.min(maxZoomValue, zoom));
}